import React from "react";
import { Users } from "../features";
import { Grid } from "@material-ui/core";

function UsersPage() {
  return (
    <>

        <Users.Container />

    </>
  );
}

export default UsersPage;
